/*
 * STICKER HUNT — рушій на вітрині leia.ua
 *
 * Що знає ця сторона: свій pid, лічильник і РІВНО ОДИН слот — той, який гравець
 * шукає зараз. Каталог зі 100 позицій лишається на сервері, у бандл не потрапляє.
 *
 * Налаштування приходять зі сніпета у window.LEIA_SH.
 */
(function () {
  'use strict';

  var CFG = window.LEIA_SH || {};
  if (!CFG.endpoint) return;

  var TOTAL    = 8;
  var HUNT_PREVIEW = false;
  var LS_KEY   = 'leia_sh_v1';
  var LS_INTRO = 'leia_sh_intro';
  var LS_PROMO = 'leia_sh_promo';   // код, який гравець уже «застосував» у кошик
  var DOT_ID   = 'leia-sh-dot';

  // ------------------------------------------------------------ стан

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(LS_KEY) || 'null') || null;
    } catch (e) {
      return null;
    }
  }

  function saveState(s) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(s));
    } catch (e) { /* приватний режим — гра просто працюватиме без кешу */ }
  }

  /*
   * Режим превʼю для тестування до старту: ?sh_preview=1.
   * Прапорець кладеться в sessionStorage, бо гра веде по різних сторінках,
   * а параметр при переході губиться. ?sh_preview=0 — вимкнути.
   */
  function previewMode() {
    // Тестова тема — гра увімкнена завжди, без параметрів в адресі.
    try { if (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '164347871490') return true; } catch (e) {}
    var q = location.search;
    try {
      if (/[?&]sh_preview=0/.test(q)) { sessionStorage.removeItem('leia_sh_preview'); return false; }
      if (/[?&]sh_preview=1/.test(q)) { sessionStorage.setItem('leia_sh_preview', '1'); return true; }
      return sessionStorage.getItem('leia_sh_preview') === '1';
    } catch (e) {
      return /[?&]sh_preview=1/.test(q);   // приватний режим — працює в межах сторінки
    }
  }

  /*
   * ?sh_pid=<pid> (лише разом із превʼю) — «стати» вказаним гравцем. Для тестів:
   * sticker-hunt/test_finish.py заводить гравця з усіма 8 стікерами й дає
   * посилання. Прогрес підтягнеться з сервера на старті.
   */
  function adoptPid() {
    var m = /[?&]sh_pid=(test-[a-zA-Z0-9_-]{4,59})(?:&|$)/.exec(location.search);
    if (!m) return;
    var cur = loadState();
    if (cur && cur.pid === m[1]) return;
    saveState({ pid: m[1], found: 0, total: TOTAL, slots: [], pending: {}, done: false });
    try { localStorage.removeItem(LS_PROMO); } catch (e) {}
  }

  /* ?sh_reset=1 — почати з нуля: новий гравець, порожній прогрес. */
  function maybeReset() {
    if (!/[?&]sh_reset=1/.test(location.search)) return;
    try {
      localStorage.removeItem(LS_KEY);
      localStorage.removeItem(LS_INTRO);
      localStorage.removeItem(LS_PROMO);
    } catch (e) {}
  }

  function newPid() {
    var a = new Uint8Array(18);
    (window.crypto || window.msCrypto).getRandomValues(a);
    var out = '';
    for (var i = 0; i < a.length; i++) out += ('0' + a[i].toString(16)).slice(-2);
    return out;
  }

  // ------------------------------------------------------------ транспорт

  /*
   * text/plain — свідомо. Apps Script не відповідає на preflight OPTIONS,
   * тому запит має лишатись "простим". Тіло все одно JSON.
   */
  function api(payload) {
    // id теми: у тестовій темі сервер пускає грати ще до старту акції.
    try { if (window.Shopify && Shopify.theme && Shopify.theme.id) payload.theme = String(Shopify.theme.id); } catch (e) {}
    return fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      // Клік не має губитись, якщо людина одразу пішла з попапу за посиланням.
      keepalive: payload.action === 'claim'
    }).then(function (r) { return r.json(); });
  }

  // ------------------------------------------------------------ шар зі стікером

  /*
   * Стікер живе у власному шарі над сторінкою, а не чіпляється до вузлів теми.
   *
   * Прив'язка до чужого DOM тут не працює: тема тримає секції під
   * content-visibility (до появи у вьюпорті вони віддають майже нульову висоту),
   * а каруселі та igrid-шаблони повні прихованих слайдів. Будь-який генеричний
   * селектор рано чи пізно влучає в невидимий вузол — і гравець застрягає на
   * кроці назавжди, бо стікера просто немає на екрані.
   *
   * Тому позиція задається двома частками: p — глибина по висоті документа,
   * x — місце по ширині. Шар нічого в темі не змінює й переживає будь-який
   * редизайн.
   */
  var LAYER_ID   = 'leia-sh-layer';
  var TOP_SAFE   = 140;   // під липкою шапкою стікер було б не дістати
  var BOT_SAFE   = 90;
  var EDGE_PX    = 12;    // відступ стікера від країв екрана

  /*
   * Стеля глибини. Головна має ~28 000 px: навіть p=0.9 означало б 25 000 px,
   * тобто три десятки екранів прокрутки — стікер там знайде хіба що випадковий
   * перехожий. На коротких сторінках межа не спрацьовує взагалі.
   */
  var MAX_DEPTH_PX = 9000;

  function layer() {
    var el = document.getElementById(LAYER_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = LAYER_ID;
      document.body.appendChild(el);
    }
    return el;
  }

  function docHeight() {
    var d = document.documentElement;
    var b = document.body;
    return Math.max(d.scrollHeight, d.offsetHeight, b.scrollHeight, b.offsetHeight);
  }

  /*
   * Нижня межа — початок підвалу, а не кінець документа. На короткій сторінці
   * (кошик, контакти) футер займає більшу частину висоти, і без цієї межі
   * більшість стікерів осідала б саме в ньому.
   */
  function contentBottom() {
    var f = document.querySelector('footer, .wt-footer');
    if (f) {
      var top = f.getBoundingClientRect().top + window.pageYOffset;
      if (top > TOP_SAFE + 300) return top - 40;
    }
    return docHeight() - BOT_SAFE;
  }

  function place(dot, a) {
    var p = typeof a.p === 'number' ? Math.min(Math.max(a.p, 0), 1) : 0.5;
    var x = typeof a.x === 'number' ? Math.min(Math.max(a.x, 0), 1) : 0.5;

    var size0 = dot.offsetWidth || 176;
    // Низ стікера, а не лише верх, має лишатись над підвалом.
    var reach = Math.min(Math.max(0, contentBottom() - TOP_SAFE - size0), MAX_DEPTH_PX);
    var top   = TOP_SAFE + p * reach;

    /*
     * По ширині рахуємо в пікселях від реального розміру стікера. Раніше це був
     * відсоток 4–92 % ширини — розрахований під 30-піксельний кружечок. Стікер
     * у 176 px при x = 92 % виїжджав правим краєм за екран на десятки пікселів,
     * а на телефоні — майже наполовину.
     */
    var vw   = document.documentElement.clientWidth || window.innerWidth || 0;
    var size = dot.offsetWidth || 176;
    var room = Math.max(0, vw - size - EDGE_PX * 2);

    var left = freeLeft(top, EDGE_PX + x * room, size, vw);
    dot.style.top  = Math.round(top) + 'px';
    dot.style.left = Math.round(left) + 'px';
  }

  /*
   * Стікер ловить кліки, тож не має лягати на кнопки й посилання сторінки
   * (на вузькому екрані 132-піксельний стікер закривав «Додати в кошик»).
   * На тій самій висоті шукаємо найближчу до задуманої вільну позицію по x;
   * якщо вільної немає — лишаємо задуману.
   */
  function freeLeft(top, want, size, vw) {
    var GAP = 6, sy = window.pageYOffset || 0;
    var blocks = [];
    var els = document.querySelectorAll('a[href], button, input, select, textarea, label, [role="button"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest && el.closest('#' + LAYER_ID)) continue;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      var t = r.top + sy, b = r.bottom + sy;
      if (b < top - GAP || t > top + size + GAP) continue;
      blocks.push([r.left - GAP, r.right + GAP]);
    }
    if (!blocks.length) return want;
    function free(l) {
      for (var k = 0; k < blocks.length; k++) if (l < blocks[k][1] && l + size > blocks[k][0]) return false;
      return true;
    }
    if (free(want)) return want;
    var best = null, bestD = Infinity, maxL = Math.max(EDGE_PX, vw - size - EDGE_PX);
    for (var l = EDGE_PX; l <= maxL; l += 12) {
      if (free(l) && Math.abs(l - want) < bestD) { bestD = Math.abs(l - want); best = l; }
    }
    return best === null ? want : best;
  }

  // ------------------------------------------------------------ стікер

  function currentPath() {
    return location.pathname.split('?')[0].replace(/\/+$/, '') || '/';
  }

  function pageMatches(page) {
    var p = currentPath();
    switch (page.t) {
      case 'index':      return p === '/';
      // Стікер «кошика» живе в боковому кошику (renderCartDot), а не на /cart:
      // на сторінку /cart із сайту не потрапити, іконка відкриває дровер.
      case 'cart':       return false;
      case 'blog':       return p === '/blogs/news';
      case 'product':    return p === '/products/' + page.h;
      case 'collection': return p === '/collections/' + page.h;
      case 'page':       return p === '/pages/' + page.h;
      default:           return false;
    }
  }

  function removeDot() {
    // Стан перемальовується кілька разів за сторінку — removeEl знімає й
    // слухачів, інакше вони копились би.
    removeEl(document.getElementById(DOT_ID));
  }

  /*
   * Усі вісім стікерів розкидані по сторінках одразу й збираються в будь-якому
   * порядку. На одній сторінці — щонайбільше один: сторінки в наборі різні.
   */
  function slotHere(state) {
    var slots = (state && state.slots) || [];
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i].found && pageMatches(slots[i].page)) return slots[i];
    }
    return null;
  }

  /* Кнопка-стікер зі своїм дизайном — спільна для сторінки й бокового кошика. */
  function makeDot(slot, id) {
    var dot = document.createElement('button');
    dot.id = id;
    dot.type = 'button';
    dot.setAttribute('aria-label', 'Стікер LEIA');

    // Кожен стікер — свій дизайн. Поки CFG.stickers порожній — кружечок-заглушка.
    var art = CFG.stickers && CFG.stickers.length
      ? CFG.stickers[(slot.art || 0) % CFG.stickers.length]
      : null;
    if (art) {
      dot.classList.add('leia-sh-dot--art');
      dot.style.backgroundImage = 'url("' + art + '")';
      // Та сама картинка як маска для голографічного переливу: відблиск
      // лягає рівно по контуру наклейки, а не прямокутником.
      dot.style.setProperty('--sh-art', 'url("' + art + '")');
    }

    dot.addEventListener('click', function () {
      if (dot.disabled) return;
      claim(slot, dot);
    });
    return dot;
  }

  function renderDot(state) {
    var slot = slotHere(state);
    var old  = document.getElementById(DOT_ID);
    // Той самий стікер уже на сторінці — лишаємо як є. Перестворення після
    // кожної відповіді сервера скидало «побачений — не рухати» (стікер знову
    // стрибав) і губило клік, що припав на момент заміни.
    if (old && slot && old._slotId === slot.id && !old.disabled && old.parentNode) return;
    removeDot();
    if (!slot) return;

    var dot = makeDot(slot, DOT_ID);
    dot._slotId = slot.id;
    layer().appendChild(dot);
    place(dot, slot.a);

    /*
     * Висота документа росте, поки довантажуються секції та картинки, —
     * перераховуємо позицію. Але лише ДОКИ стікер не зʼявився на екрані.
     *
     * Тема тримає секції під content-visibility: вони набувають справжньої
     * висоти, коли до них докручують. Підвал від цього їде вниз, частка p
     * дає нову точку — і стікер, на який людина вже дивилась чи навела
     * курсор, стрибав кудись за екран («навівся — і він пропав»).
     * Тож побачений стікер фіксуємо; далі рухає його лише зміна ширини
     * вікна (поворот телефона), бо від неї залежить x.
     */
    var locked = false;
    var lastW  = window.innerWidth;
    var reflow = function () { if (!locked) place(dot, slot.a); };
    var widthTimer = null;
    var onResize = function () {
      if (window.innerWidth !== lastW) {
        // Поворот телефона: тема перебудовує сторінку не одразу. Рахувати
        // посеред перебудови — отримати висоту підвалу «на льоту» і посадити
        // стікер у підвал. Чекаємо, поки розкладка устоїться, і звіряємо ще раз.
        lastW = window.innerWidth;
        clearTimeout(widthTimer);
        widthTimer = setTimeout(function () {
          place(dot, slot.a);
          setTimeout(function () { place(dot, slot.a); }, 900);
        }, 450);
      } else reflow();
    };
    window.addEventListener('resize', onResize);
    dot._onResize = onResize;
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(reflow);
      ro.observe(document.body);
      dot._ro = ro;
    }
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) { locked = true; io.disconnect(); }
      }, { threshold: 0.25 });
      io.observe(dot);
      dot._io = io;
    }
    window.addEventListener('load', reflow);
    setTimeout(reflow, 1200);
    setTimeout(reflow, 3500);
  }

  // ------------------------------------------------------------ боковий кошик

  /*
   * Стікер «кошика» живе в боковому кошику теми (<cart-drawer>, панель
   * #CartDrawer), а не на сторінці /cart: іконка в шапці відкриває дровер, і на
   * /cart із сайту не потрапити, не знаючи адреси.
   *
   * Панель є в DOM на кожній сторінці, навіть із порожнім кошиком, і має
   * position: fixed — тож стікер кладемо прямо в неї: видно його лише коли
   * кошик відкрито, і виїжджає він разом із панеллю.
   */
  var CART_DOT_ID = 'leia-sh-dot-cart';
  var cartObserver = null;

  function cartSlot(state) {
    var slots = (state && state.slots) || [];
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i].found && slots[i].page.t === 'cart') return slots[i];
    }
    return null;
  }

  function renderCartDot(state) {
    var panel = document.getElementById('CartDrawer');
    var slot  = cartSlot(state);
    var old   = document.getElementById(CART_DOT_ID);
    if (!panel || !slot) { removeEl(old); return; }
    if (old && old.parentNode === panel && !old.disabled) return;   // уже на місці
    removeEl(old);

    var dot = makeDot(slot, CART_DOT_ID);
    panel.appendChild(dot);
    placeInPanel(dot, slot.a, panel);
    watchCartDrawer();

    // Панель нерухома, а список товарів під стікером прокручується — після
    // прокрутки знову шукаємо місце, вільне від кнопок.
    if (!panel._shScroll) {
      var t = null;
      panel._shScroll = function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var d = document.getElementById(CART_DOT_ID), sl = cartSlot(loadState());
          if (d && sl) placeInPanel(d, sl.a, panel);
        }, 150);
      };
      panel.addEventListener('scroll', panel._shScroll, true);
    }
  }

  /*
   * Позиція в панелі. Стікер ловить кліки, тож лягти на кнопку не можна —
   * а розкладка кошика різна: у порожньому «Продовжити покупки» стоїть
   * посередині, з товарами — інші кнопки й поля. Фіксоване правило «тримайся
   * верхньої половини» саме на цю кнопку й лягало.
   *
   * Тому перебираємо позиції сіткою, відкидаємо ті, що перетинають будь-який
   * інтерактивний елемент панелі, і беремо вільну, найближчу до задуманої.
   * Перераховується при кожному відкритті й зміні кошика (watchCartDrawer).
   */
  function placeInPanel(dot, a, panel) {
    var pr   = panel.getBoundingClientRect();
    var w    = pr.width  || 500;
    var h    = pr.height || window.innerHeight;
    var size = dot.offsetWidth || 128;
    var p = typeof a.p === 'number' ? Math.min(Math.max(a.p, 0), 1) : 0.5;
    var x = typeof a.x === 'number' ? Math.min(Math.max(a.x, 0), 1) : 0.5;

    var wantTop  = h * 0.16 + p * Math.max(0, h * 0.5 - size);
    var wantLeft = EDGE_PX + x * Math.max(0, w - size - EDGE_PX * 2);

    var GAP = 6;
    function box(r) {
      return { l: r.left - pr.left - GAP, t: r.top - pr.top - GAP,
               r: r.right - pr.left + GAP, b: r.bottom - pr.top + GAP };
    }
    function real(b) { return b.r > b.l && b.b > b.t; }

    // Кнопки й поля — стікер ловить кліки, тож на них лягати не можна ніколи.
    var hard = [].slice.call(panel.querySelectorAll(
      'a, button, input, select, textarea, label, [role="button"]'))
      .filter(function (el) { return el !== dot && el.offsetParent !== null; })
      .map(function (el) { return box(el.getBoundingClientRect()); })
      .filter(real);

    // Текст та іконки — перекривати небажано («Подарунок!», «Маєте обліковий
    // запис?»). Межі тексту беремо по самих рядках, а не по блоках-обгортках,
    // інакше широкі контейнери забирали б усю панель.
    var soft = [];
    var walker = document.createTreeWalker(panel, NodeFilter.SHOW_TEXT, null);
    for (var node = walker.nextNode(); node; node = walker.nextNode()) {
      if (!node.nodeValue.trim() || dot.contains(node)) continue;
      var range = document.createRange();
      range.selectNodeContents(node);
      var rs = range.getClientRects();
      for (var k = 0; k < rs.length; k++) soft.push(box(rs[k]));
    }
    [].slice.call(panel.querySelectorAll('img, svg')).forEach(function (el) {
      if (!dot.contains(el) && el.offsetParent !== null) soft.push(box(el.getBoundingClientRect()));
    });
    soft = soft.filter(real);

    function free(blocks, l, t) {
      for (var i = 0; i < blocks.length; i++) {
        var b = blocks[i];
        if (l < b.r && l + size > b.l && t < b.b && t + size > b.t) return false;
      }
      return true;
    }

    // Спершу шукаємо місце без кнопок І без тексту; якщо такого немає
    // (повний кошик) — хоча б без кнопок.
    function search(blocks) {
      var best = null, bestD = Infinity;
      var maxL = Math.max(EDGE_PX, w - size - EDGE_PX);
      var maxT = Math.max(60, h - size - 90);   // низ панелі — футер і «Оформити»
      for (var t = 60; t <= maxT; t += 16) {
        for (var l = EDGE_PX; l <= maxL; l += 16) {
          if (!free(blocks, l, t)) continue;
          var d = (l - wantLeft) * (l - wantLeft) + (t - wantTop) * (t - wantTop);
          if (d < bestD) { bestD = d; best = [l, t]; }
        }
      }
      return best;
    }

    var pos = search(hard.concat(soft)) || search(hard) || [wantLeft, wantTop];
    dot.style.left = Math.round(pos[0]) + 'px';
    dot.style.top  = Math.round(pos[1]) + 'px';
  }

  /*
   * Тема перемальовує вміст кошика при кожній зміні (додали, прибрали,
   * змінили кількість) і разом із ним викидає наш стікер. Стежимо й
   * повертаємо; а при відкритті — перераховуємо позицію під реальний розмір.
   */
  /*
   * Рядок із персональним кодом у підвалі бокового кошика.
   *
   * Код закріплений за покупцем, тож Shopify в анонімному кошику не показує
   * його серед знижок (discount_codes → applicable: false) — кошик виглядав
   * так, ніби кнопка «Застосувати» нічого не зробила. Показуємо його самі,
   * коли гравець натиснув «Застосувати» (LS_PROMO) і в кошику є товари.
   */
  // Рядок із кодом у боковому кошику прибрано на прохання замовника (30.09):
  // код підхоплює чекаут, стікер-пак додається сам. Функція лише прибирає
  // старий рядок, якщо він лишився від попередньої версії.
  function renderCartPromo() {
    var old = document.querySelector('#CartDrawer .leia-sh-cart-promo');
    if (old) old.parentNode.removeChild(old);
  }

  /*
   * Стікер-пак живе в кошику лише разом із платними товарами й кодом гри:
   * зʼявились товари — додаємо пак (1 шт.), товарів не лишилось — прибираємо.
   * Спрацьовує на кожну зміну бокового кошика (додали з картки, змінили
   * кількість). Остаточно те саме правило тримають чекаут і сервер оплати.
   */
  var PACK_VARIANT = '48514170323202';
  var packBusy = false;
  function syncPack() {
    var s = loadState(), code = null;
    try { code = localStorage.getItem(LS_PROMO); } catch (e) {}
    if (packBusy || !code || !s || s.code !== code) return Promise.resolve();
    packBusy = true;
    var json = function (r) { return r.json(); };
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    };
    return fetch('/cart.js').then(json).then(function (cart) {
      var items = cart.items || [];
      var packs = items.filter(function (i) { return String(i.variant_id) === PACK_VARIANT; });
      var paid  = items.some(function (i) { return String(i.variant_id) !== PACK_VARIANT && i.final_price > 0; });
      var req = null, upd = {};
      if (!paid && packs.length) {
        packs.forEach(function (p) { upd[p.key] = 0; });
        req = post('/cart/update.js', { updates: upd });
      } else if (paid && !packs.length) {
        req = post('/cart/add.js', { items: [{ id: Number(PACK_VARIANT), quantity: 1 }] });
      } else if (paid && (packs.length > 1 || packs[0].quantity !== 1)) {
        packs.forEach(function (p, i) { upd[p.key] = i === 0 ? 1 : 0; });
        req = post('/cart/update.js', { updates: upd });
      }
      if (!req) return;
      return req.then(refreshDrawer);
    }).catch(function () {}).then(function () {
      setTimeout(function () { packBusy = false; }, 800);
    });
  }

  /*
   * Стікер-пак у боковому кошику — як подарунок теми (styleGiftItems у
   * cart-bonus-progress-bar): без лічильника й кошика, з бейджем
   * «Подарунок 🎁». Кількість і так тримається рівно 1 (syncPack, чекаут, сервер).
   */
  function stylePackItems() {
    var items = document.querySelectorAll('#CartDrawer .wt-cart__list > li');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.getAttribute('data-sh-pack') || (item.innerHTML || '').indexOf(PACK_VARIANT) === -1) continue;
      item.setAttribute('data-sh-pack', '1');
      var hide = item.querySelectorAll('[class*="counter"], [class*="quantity"], [class*="remove"], [class*="delete"], cart-remove-button');
      for (var k = 0; k < hide.length; k++) hide[k].style.display = 'none';
      if (!item.querySelector('.bonus-gift-badge')) {
        var badge = document.createElement('div');
        badge.className = 'bonus-gift-badge';
        badge.textContent = 'Подарунок 🎁';
        var anchor = item.querySelector('[class*="counter"], [class*="quantity"]');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(badge, anchor);
        else item.appendChild(badge);
      }
    }
  }

  function refreshDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || typeof d.renderContents !== 'function') return;
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) { d.renderContents({ sections: sections }, false); })
      .catch(function () {});
  }

  function watchCartDrawer() {
    if (cartObserver || !window.MutationObserver) return;
    var host = document.querySelector('cart-drawer');
    if (!host) return;
    var pending = null;
    cartObserver = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        var s = loadState();
        var dot = document.getElementById(CART_DOT_ID);
        var slot = cartSlot(s);
        renderCartPromo(s);
        syncPack();
        stylePackItems();
        if (slot && !dot) { renderCartDot(s); return; }
        if (slot && dot) placeInPanel(dot, slot.a, document.getElementById('CartDrawer'));
      }, 120);
    });
    cartObserver.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  /*
   * Клік засчитується ОДРАЗУ: стікер зникає, лічильник росте, вікно з
   * підказкою відкривається без очікування мережі. Раніше людина чекала
   * відповіді Apps Script — близько двох секунд.
   *
   * Сервер отримує клік у фоні й лишається суддею. Якщо відмовив (чужий слот,
   * не та сторінка) — відкочуємо. Якщо пропала мережа — клік лежить у черзі
   * pending і досилається на наступній сторінці.
   */
  var MIN_CLAIM_MS = 2500;   // той самий поріг, що на сервері

  function claim(slot, dot) {
    var s = loadState();
    if (!s || !s.pid) return;

    var now = Date.now();
    if (s.lastClaim && now - s.lastClaim < MIN_CLAIM_MS) {
      toast('Не поспішай. Спробуй ще раз за мить.');
      return;
    }

    dot.disabled = true;
    dot.classList.add('leia-sh-dot--taken');   // мінімалістичне зникнення, .42 с

    s.pending = s.pending || {};
    s.pending[slot.id] = { path: currentPath(), at: now };
    s.lastClaim = now;
    setFound(s, slot.id, true);
    saveState(s);
    paintNav(s);
    announce(s);

    // На сервер — одразу, у фоні; анімація на це не чекає.
    sendClaim(s.pid, slot.id, s.pending[slot.id].path);

    // Спершу стікер розчиняється, і лише потім вікно зі знахідкою —
    // не одночасно, інакше анімацію не видно за оверлеєм.
    setTimeout(function () {
      removeEl(dot);
      foundPopup(loadState() || s);
    }, COLLECT_MS);
  }

  var COLLECT_MS = 440;   // тривалість leia-sh-collect у CSS + запас на кадр

  function removeEl(dot) {
    if (!dot || !dot.parentNode) return;
    if (dot._ro) dot._ro.disconnect();
    if (dot._io) dot._io.disconnect();
    if (dot._onResize) window.removeEventListener('resize', dot._onResize);
    dot.parentNode.removeChild(dot);
  }

  function setFound(s, slotId, value) {
    (s.slots || []).forEach(function (sl) { if (sl.id === slotId) sl.found = value; });
    s.found = (s.slots || []).filter(function (sl) { return sl.found; }).length;
    s.done  = s.found >= (s.total || TOTAL);
  }

  function sendClaim(pid, slotId, path, attempt) {
    attempt = attempt || 0;
    var sentAt = Date.now();
    return api({ action: 'claim', pid: pid, slotId: slotId, path: path })
      .then(function (res) {
        if (res && res.ok) {
          // Час підтвердження знахідки: старіші відповіді start/state її вже не скасують.
          var st = loadState();
          if (st) { st.confirmedAt = st.confirmedAt || {}; st.confirmedAt[slotId] = Date.now(); saveState(st); }
          mergeServer(res, sentAt);
          return true;
        }
        /*
         * too_fast — не відмова, а збіг у часі: сервер рахує паузу за моментом
         * ПРИХОДУ запиту, і повільний попередній запит може стиснути чесні
         * три секунди до однієї. Не відкочуємо — повторюємо трохи пізніше.
         */
        if (res && res.error === 'too_fast' && attempt < 5) {
          return new Promise(function (r) { setTimeout(r, 1500); })
            .then(function () { return sendClaim(pid, slotId, path, attempt + 1); });
        }
        /*
         * Відкочуємо лише справжню відмову: чужий слот або не та сторінка.
         * server_error (таймаут блокування під навантаженням), not_started,
         * no_player, HTML-сторінка помилки замість JSON — не вина гравця:
         * знахідка лишається в черзі й досилається пізніше. Раніше на старті
         * акції вже показане «Знайдено!» могло змінитись на «не зараховано».
         */
        var err = res && res.error;
        if (err === 'wrong_slot' || err === 'wrong_page') {
          rollback(slotId, err);
          return false;
        }
        return null;
      })
      .catch(function () { return null; });   // мережа — лишаємо в черзі
  }

  function rollback(slotId, error) {
    var s = loadState();
    if (!s) return;
    if (s.pending) delete s.pending[slotId];
    setFound(s, slotId, false);
    saveState(s);
    paintNav(s);
    renderDot(s);
    renderCartDot(s);
    announce(s);
    toast('Цей стікер не зараховано. Спробуй ще раз.');
  }

  /*
   * Досилаємо кліки, що не дійшли до сервера (пропадала мережа). По одному,
   * з інтервалом — інакше сервер прийняв би їх за скрипт.
   */
  function flushPending() {
    var s = loadState();
    if (!s || !s.pending) return Promise.resolve();
    var ids = Object.keys(s.pending);
    return ids.reduce(function (chain, id, i) {
      return chain
        .then(function () { return i ? new Promise(function (r) { setTimeout(r, 1200); }) : null; })
        .then(function () { return sendClaim(s.pid, id, s.pending[id].path); });
    }, Promise.resolve());
  }

  // ------------------------------------------------------------ попапи

  function modal(html, onClose) {
    var wrap = document.createElement('div');
    wrap.className = 'leia-sh-overlay';
    wrap.innerHTML = '<div class="leia-sh-modal" role="dialog" aria-modal="true">' + html + '</div>';
    document.body.appendChild(wrap);

    /*
     * rAF у прихованій вкладці не викликається взагалі, тож на самому лише
     * ньому модалка лишилась би з opacity:0 і pointer-events:none — тобто
     * недосяжною. Таймер страхує; додавання класу ідемпотентне.
     */
    var open = function () { wrap.classList.add('is-open'); };
    requestAnimationFrame(open);
    setTimeout(open, 60);

    var prevFocus = document.activeElement;
    var onKey = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    // Фокус — на саме вікно, а не на кнопку: інакше тема малює червоне
    // кільце фокуса навколо хрестика.
    setTimeout(function () {
      var m = wrap.querySelector('.leia-sh-modal');
      if (m && m.focus) try { m.setAttribute('tabindex', '-1'); m.focus({ preventScroll: true }); } catch (e) {}
    }, 80);

    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      document.removeEventListener('keydown', onKey);
      wrap.classList.remove('is-open');
      setTimeout(function () {
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      }, 200);
      if (prevFocus && prevFocus.focus && document.contains(prevFocus)) try { prevFocus.focus({ preventScroll: true }); } catch (e) {}
      if (onClose) onClose();
    }

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap || (e.target.dataset && e.target.dataset.shClose !== undefined)) close();
    });
    return { el: wrap, close: close };
  }

  function progressDots(found, total) {
    var out = '';
    for (var i = 0; i < total; i++) {
      out += '<span class="leia-sh-pip' + (i < found ? ' is-on' : '') + '"></span>';
    }
    return '<div class="leia-sh-pips">' + out + '</div>';
  }

  /*
   * Випадкова підказка про ОДИН із ще не знайдених стікерів.
   *
   * Спершу вибираємо стікер, потім фразу — так кожна ненайдена сторінка
   * однаково ймовірна, скільки б фраз у неї не було. Повторно ту саму
   * сторінку поспіль не даємо, поки є інші. Знайдені стікери з пулу випадають:
   * підказка про вже зібране нікому не потрібна.
   */
  function hintFor(state, avoidSlotId) {
    var left = ((state && state.slots) || []).filter(function (sl) {
      return !sl.found && sl.hints && sl.hints.length;
    });
    if (!left.length) return null;
    var pool = left.length > 1
      ? left.filter(function (sl) { return sl.id !== avoidSlotId; })
      : left;
    var sl = pool[Math.floor(Math.random() * pool.length)];
    return { slotId: sl.id, text: sl.hints[Math.floor(Math.random() * sl.hints.length)] };
  }

  function foundPopup(s) {
    var total = s.total || TOTAL;
    var body;

    if (s.done) {
      body =
        '<div class="leia-sh-kicker">Усі ' + total + ' знайдено</div>' +
        '<h3>Полювання завершено</h3>' +
        progressDots(s.found, total) +
        '<p>Забирай персональну знижку -15% і стікер-пак у подарунок.</p>' +
        '<a class="leia-sh-btn" href="' + CFG.huntPage + '">Забрати подарунок</a>';
    } else {
      var hint = hintFor(s);
      body =
        '<div class="leia-sh-kicker">Стікер ' + s.found + ' з ' + total + '</div>' +
        '<h3>Знайдено!</h3>' +
        progressDots(s.found, total) +
        '<p class="leia-sh-left">Лишилось ще ' + (total - s.found) + '.</p>' +
        (hint
          ? '<div class="leia-sh-hint' + ((total - s.found) > 1 ? ' leia-sh-hint--more' : '') + '"><span>Підказка</span>' +
            '<em data-sh-hint-text>' + escapeHtml(hint.text) + '</em>' +
            ((total - s.found) > 1
              ? '<button class="leia-sh-more" type="button" data-sh-more aria-label="Інша підказка" title="Інша підказка">' + REFRESH_ICON + '</button>'
              : '') +
            '</div>'
          : '') +
        '<button class="leia-sh-btn" type="button" data-sh-close>Шукати далі</button>' +
        '<a class="leia-sh-link" href="' + CFG.huntPage + '">Мій прогрес</a>';
    }

    var m = modal('<button class="leia-sh-x" type="button" data-sh-close aria-label="Закрити">&times;</button>' + body);

    // «Інша підказка» — щоразу про інший ненайдений стікер, без звернення до сервера.
    var more = m.el.querySelector('[data-sh-more]');
    if (more) {
      var current = hint;
      more.addEventListener('click', function () {
        current = hintFor(loadState(), current && current.slotId) || current;
        m.el.querySelector('[data-sh-hint-text]').textContent = current.text;
        spin(more);
      });
    }
  }

  // Іконка «оновити» для кнопки іншої підказки (попап і сторінка гри).
  var REFRESH_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M20.5 3.5v5h-5"/></svg>';

  // Один оберт іконки на клік — видно, що підказка змінилась.
  function spin(btn) {
    btn.classList.remove('is-spin');
    void btn.offsetWidth;
    btn.classList.add('is-spin');
  }

  function introPopup(onStart) {
    // Показ фіксуємо лише коли вікно справді зʼявилось: якщо людина пішла
    // зі сторінки раніше, воно має спробувати ще раз, а не зникнути назавжди.
    markIntroShown();
    introState = 'open';
    var m = modal(
      '<button class="leia-sh-x" type="button" data-sh-close aria-label="Закрити">&times;</button>' +
      '<h3 class="leia-sh-title">Полювання за стікерами</h3>' +
      '<p>На сайті сховано 8 стікерів. Знайди всі — отримаєш персональну знижку -15% і стікер-пак у подарунок. Гра триває до 12 жовтня включно.</p>' +
      '<button class="leia-sh-btn" type="button" data-sh-start>Почати</button>' +
      '<button class="leia-sh-link" type="button" data-sh-close>Не зараз</button>',
      introDone
    );
    m.el.querySelector('[data-sh-start]').addEventListener('click', function () {
      m.close();
      onStart();
    });
  }

  /*
   * Черговість із лід-попапом теми (sections/lead-popup.liquid): гра головніша.
   * Вітальне вікно гри виходить одразу при заході, а лід — через 10 с після
   * того, як вікно гри закрили. Лід сам питає про це в introWillShow() і чекає
   * на подію leia-sh:intro-done.
   *
   * Стан: none — вікна на цій сторінці не буде; pending — заплановане; open —
   * відкрите; done — закрите або від показу відмовились.
   */
  var introState = 'none';

  function introDone() {
    if (introState === 'done') return;
    introState = 'done';
    document.dispatchEvent(new CustomEvent('leia-sh:intro-done'));
  }

  /*
   * На сайті вже живуть свої попапи (лід-попап, опитування). Два модали
   * одночасно — зіпсований екран, тому автозапуск свого чекає, поки чужий піде.
   */
  var OTHER_POPUPS = '#shopify-section-lead-popup, #shopify-section-survey-popup, #shopify-section-valentine-popup';

  function otherModalOpen() {
    var hosts = document.querySelectorAll(OTHER_POPUPS);
    for (var i = 0; i < hosts.length; i++) {
      var nodes = hosts[i].querySelectorAll('*');
      for (var j = 0; j < nodes.length; j++) {
        var r = nodes[j].getBoundingClientRect();
        if (r.width > 220 && r.height > 220) {
          var cs = window.getComputedStyle(nodes[j]);
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) return true;
        }
      }
    }
    return false;
  }

  /*
   * Чекаємо, поки чужий попап піде. Якщо за пів хвилини не пішов — сьогодні на
   * цій сторінці НЕ показуємо зовсім, а не вискакуємо поверх нього: два модали
   * одне на одному і є той конфлікт. Спробуємо на наступній сторінці.
   */
  function whenFree(fn, tries) {
    tries = tries || 0;
    if (!otherModalOpen()) { fn(); return; }
    // Відмовились від показу — лід не має чекати вічно на вікно, якого не буде.
    if (tries > 20) { introDone(); return; }
    setTimeout(function () { whenFree(fn, tries + 1); }, 1500);
  }

  /*
   * Вітальне вікно гри — не частіше разу на день для однієї людини.
   * Дата локальна, не UTC: інакше в Україні «новий день» наставав би о 02:00–03:00.
   */
  function todayKey() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function introShownToday() {
    try { return localStorage.getItem(LS_INTRO) === todayKey(); } catch (e) { return false; }
  }

  function markIntroShown() {
    try { localStorage.setItem(LS_INTRO, todayKey()); } catch (e) {}
  }

  function toast(text) {
    var t = document.createElement('div');
    t.className = 'leia-sh-toast';
    t.textContent = text;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 250);
    }, 2600);
  }

  // ------------------------------------------------------------ склейка

  function announce(s) {
    document.dispatchEvent(new CustomEvent('leia-sh:state', { detail: s }));
  }

  /*
   * Стан із сервера зливаємо з локальним. Сервер головний щодо вже
   * підтверджених знахідок, але кліки з черги pending (засчитані на вітрині,
   * ще не підтверджені) лишаються знайденими — інакше стікер, щойно зібраний,
   * на мить повернувся б на сторінку.
   */
  /*
   * sentAt — коли запит пішов на сервер. Відповіді приходять за 2–10 с і не
   * по черзі: стан, запитаний ДО кліку, міг прийти ПІСЛЯ підтвердження кліку
   * й «роззнаходив» стікер (він знову зʼявлявся, лічильник падав). Знахідку,
   * підтверджену сервером пізніше за відправку цього запиту, не скасовуємо.
   */
  function mergeServer(res, sentAt) {
    var s = loadState() || {};
    var pending = s.pending || {};
    var confirmed = s.confirmedAt || {};
    s.slots = (res.slots || []).map(function (sl) {
      if (sl.found) delete pending[sl.id];
      var fresh = sentAt && confirmed[sl.id] && confirmed[sl.id] > sentAt;
      return {
        id: sl.id, page: sl.page, a: sl.a, hints: sl.hints, art: sl.art,
        found: !!(sl.found || pending[sl.id] || fresh)
      };
    });
    s.pending = pending;
    s.total   = res.total || TOTAL;
    s.found   = s.slots.filter(function (sl) { return sl.found; }).length;
    s.done    = s.found >= s.total;
    s.code    = res.code || null;
    s.codeEndsAt = res.codeEndsAt || null;
    s.syncedAt = Date.now();
    saveState(s);

    paintNav(s);
    renderDot(s);
    renderCartDot(s);
    announce(s);
  }

  function start() {
    var s = loadState();
    // Свіжий стан і нічого не чекає відправки — сервер не смикаємо на кожен
    // перегляд сторінки (на старті акції це тисячі зайвих запитів).
    if (s && s.pid && s.slots && s.slots.length && s.syncedAt &&
        Date.now() - s.syncedAt < 60000 && !Object.keys(s.pending || {}).length) {
      return;
    }
    if (!s || !s.pid) {
      s = { pid: newPid(), found: 0, total: TOTAL, slots: [], pending: {}, done: false };
      saveState(s);
    }

    var pid = s.pid;
    /*
     * Перший старт: місця стікерів знає лише сервер, відповідь — 3–4 с (на
     * старті акції довше). Без підказки це виглядало як «стікер вантажиться
     * із запізненням» — кажемо, що відбувається.
     */
    var fresh = !(s.slots && s.slots.length);
    if (fresh) toast('Розкладаємо стікери по сайту…');
    var ref = (function () { try { return document.referrer ? new URL(document.referrer).origin : ''; } catch (e) { return ''; } })();
    (function attempt(n) {
      var sentAt = Date.now();
      api({ action: 'start', pid: pid, ua: navigator.userAgent, ref: ref }).then(function (res) {
        if (res && res.ok) {
          mergeServer(res, sentAt);
          flushPending();
          if (fresh) toast('Готово! Стікери вже чекають — шукай.');
          return;
        }
        // Черга на сервері переповнена (старт акції) — повторюємо з паузою.
        if (res && res.error === 'busy' && n < 3) setTimeout(function () { attempt(n + 1); }, 3000 + Math.random() * 4000);
      }).catch(function () {
        // Сервер недоступний — малюємо по кешу; кліки ляжуть у чергу.
        renderDot(loadState() || s);
        renderCartDot(loadState() || s);
      });
    })(0);
  }

  /* Пункт меню лежить у шапці схованим і відкривається лише коли гра жива. */
  function revealNav() {
    var items = document.querySelectorAll('[data-sh-nav]');
    for (var i = 0; i < items.length; i++) items[i].hidden = false;
  }

  function paintNav(state) {
    var badges = document.querySelectorAll('[data-sh-nav-count]');
    for (var i = 0; i < badges.length; i++) {
      if (state && state.pid && !state.code) {
        badges[i].textContent = (state.found || 0) + '/' + (state.total || TOTAL);
        badges[i].hidden = false;
      } else {
        badges[i].hidden = true;
      }
    }
  }

  // Знахідка в іншій вкладці — оновлюємо лічильник і стікери тут.
  window.addEventListener('storage', function (e) {
    if (e.key !== LS_KEY || !e.newValue) return;
    var s = loadState();
    if (!s || !s.pid) return;
    paintNav(s);
    if (!s.done) { renderDot(s); renderCartDot(s); } else { removeDot(); removeEl(document.getElementById(CART_DOT_ID)); }
    announce(s);
  });

  /*
   * Після кінця гри (12.10): жодних стікерів, меню й вікон. Але виграні коди
   * діють 90 днів — тож власнику коду стікер-пак і далі сам лягає в бічний
   * кошик разом із товарами (як подарунок), а код підхоплює чекаут.
   */
  function postGame() {
    var s = loadState();
    if (!s || !s.code) return;
    try { if (!localStorage.getItem(LS_PROMO)) localStorage.setItem(LS_PROMO, s.code); } catch (e) {}
    stylePackItems();
    watchCartDrawer();
    syncPack();
  }

  function boot() {
    maybeReset();

    var preview = previewMode();
    HUNT_PREVIEW = preview;
    if (preview) adoptPid();
    if (CFG.startsAt && Date.now() < Date.parse(CFG.startsAt) && !preview) return;
    // Гру завершено (після 12.10 включно) — ні стікерів, ні пункту меню, ні вітального вікна.
    if (CFG.endsAt && Date.now() > Date.parse(CFG.endsAt) && !preview) { postGame(); return; }

    revealNav();
    paintNav(loadState());

    var s = loadState();
    if (s && s.pid) {
      if (!s.done) { renderDot(s); renderCartDot(s); }  // миттєвий рендер по кешу, без очікування мережі
      if (s.code) { renderCartPromo(s); stylePackItems(); watchCartDrawer(); }
      start();
      return;
    }

    if (introShownToday()) return;

    /*
     * У фоновій вкладці таймер відпрацює, і при поверненні людину зустріне
     * попап, що вискочив нізвідки. Чекаємо, поки вкладку справді дивляться.
     */
    // Стан ставимо одразу, синхронно: лід вирішує на DOMContentLoaded, а цей
    // рушій (defer) відпрацьовує раніше — до того моменту лід уже знає, що чекати.
    introState = 'pending';

    // Одразу при заході — лише коротка пауза, щоб сторінка встигла відмалюватись.
    /*
     * Тема показує білий екран із логотипом (.preloader) і ховає його через
     * 0,9–1,6 с + 0,4 с згасання. Вікно гри має зʼявитись ПІСЛЯ нього, а не
     * поверх: чекаємо, поки заставка зникне (не довше 5 с), і ще мить.
     */
    var afterPreloader = function (fn) {
      var t0 = Date.now();
      (function check() {
        var p = document.querySelector('.preloader');
        var gone = !p || p.classList.contains('d-none') || getComputedStyle(p).display === 'none';
        if (gone || Date.now() - t0 > 5000) { setTimeout(fn, gone && p ? 250 : 0); return; }
        setTimeout(check, 150);
      })();
    };
    var scheduleIntro = function () {
      setTimeout(function () {
        afterPreloader(function () { whenFree(function () { introPopup(start); }); });
      }, 700);
    };
    if (document.hidden) {
      document.addEventListener('visibilitychange', function once() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', once);
        scheduleIntro();
      });
    } else {
      scheduleIntro();
    }
  }

  // ------------------------------------------------------------ дрібне

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  window.LeiaStickerHunt = {
    state: loadState,
    total: CFG.total || TOTAL,
    start: start,
    isPreview: function () { return HUNT_PREVIEW; },
    // Для лід-попапу теми: чи є на цій сторінці вітальне вікно гри, яке треба
    // пропустити вперед. Коли воно закриється — прийде подія leia-sh:intro-done.
    introWillShow: function () { return introState === 'pending' || introState === 'open'; },
    // Для сторінки гри: випадкова підказка про ще не знайдений стікер.
    randomHint: function (avoidSlotId) { return hintFor(loadState(), avoidSlotId); },
    // Для сторінки гри: код «застосовано» — показуємо його в боковому кошику.
    stylePack: function () { stylePackItems(); },
    promoInCart: function (code) {
      try { localStorage.setItem(LS_PROMO, code); } catch (e) {}
      renderCartPromo(loadState());
      watchCartDrawer();
      return syncPack();
    },
    refresh: function () {
      var s = loadState();
      if (!s || !s.pid) return Promise.resolve(null);
      var sentAt = Date.now();
      return api({ action: 'state', pid: s.pid }).then(function (res) {
        if (res && res.ok) mergeServer(res, sentAt);
        return res;
      });
    },
    redeem: function (contact) {
      var s = loadState();
      if (!s || !s.pid) return Promise.resolve({ ok: false, error: 'no_player' });
      /*
       * Останній стікер вітрина засчитує одразу, а на сервер він іде у фоні.
       * Людина може встигнути натиснути «Забрати подарунок» раніше, ніж клік
       * дійде, — тоді сервер відповів би not_finished. Тому спершу досилаємо чергу.
       */
      return flushPending().then(function () {
        return api({
          action: 'redeem',
          pid: s.pid,
          email: contact.email || '',
          phone: contact.phone || '',
          consent: contact.consent === true
        });
      }).then(function (res) {
        if (res && res.ok && res.code) {
          // Перечитуємо: досилка черги вже оновила стан, стара копія його б затерла.
          var fresh = loadState() || s;
          fresh.code = res.code;
          fresh.codeEndsAt = res.codeEndsAt || null;
          saveState(fresh);
          paintNav(fresh);
        }
        return res;
      });
    }
  };

  /*
   * Рушій вантажиться з defer, тобто ПІЗНІШЕ за інлайнові скрипти сторінок.
   * Сторінка гри читає window.LeiaStickerHunt і без цього сигналу бачила б
   * undefined та назавжди показувала «Скоро».
   */
  HUNT_PREVIEW = previewMode();
  document.dispatchEvent(new CustomEvent('leia-sh:ready'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
